var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"iContent"}},[_c('div',[_c('div',[_c('div',[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.tableData.images}})]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"18px","line-height":"2.5rem"},domProps:{"innerHTML":_vm._s(_vm.tableData.contents)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd57c9fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/introduction.vue
// module id = null
// module chunks = 